"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.error = exports.issue = exports.debug = exports.setCustomLogger = void 0;
var errorMessage = 'Logger not yet initialized, please use setCustomLogger function first';
var logger = {
    debug: function () { },
    issue: function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        console.error.apply(console, params);
    },
    error: function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        console.error.apply(console, params);
    },
};
var setCustomLogger = function (customLogger) {
    if ((customLogger === null || customLogger === void 0 ? void 0 : customLogger.debug) && (customLogger === null || customLogger === void 0 ? void 0 : customLogger.error) && (customLogger === null || customLogger === void 0 ? void 0 : customLogger.issue)) {
        logger = customLogger;
    }
    else {
        throw new Error('Incorrect logger supplied');
    }
};
exports.setCustomLogger = setCustomLogger;
var debug = function () {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    if (logger) {
        return logger.debug.apply(logger, params);
    }
    throw new Error(errorMessage);
};
exports.debug = debug;
var issue = function () {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    if (logger) {
        return logger.issue.apply(logger, params);
    }
    throw new Error(errorMessage);
};
exports.issue = issue;
var error = function () {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    if (logger) {
        return logger.error.apply(logger, params);
    }
    throw new Error(errorMessage);
};
exports.error = error;
